
import { Vue, Component } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import mwx from '@/store/modules/mediumwarex';
import progressToastx from '@/store/modules/progressToastx';
import programx from '@/store/modules/programx';

import {
	SoftwareType,
	CreateAccountSubmission,
	EditState,
} from '@/store/models.def';
import moment from 'moment';

@Component({
	components: {},
})
export default class CreateAccount extends Vue {
	public companyName = '';
	public companyRemark = '';
	public path = 'localhost/3050:';
	public payroll = '';
	public interval: string | number = 300;
	public softwareType: SoftwareType = 'sql';
	public programId = 'sql-default';

	public validateNow = false;
	public createAccountState: EditState = 'active';

	public get year() {
		return moment()
			.year()
			.toString();
	}

	public get softwareTypesVt() {
		return mwx.softwareTypesVt;
	}
	public get availablePrograms(): Array<string | { value: any; text: string }> {
		const programs = programx.allPrograms;
		return programs.map((pg) => pg.id);
	}

	public get validateCompanyName() {
		if (!this.validateNow) {
			return null;
		}
		return this.companyName !== '';
	}
	public get validatePath() {
		if (!this.validateNow) {
			return null;
		}
		return this.path.substr(-4).toLocaleLowerCase() === '.fdb';
	}
	public get validatePayroll() {
		if (!this.validateNow) {
			return null;
		}
		return (
			!this.payroll || this.payroll.substr(-4).toLocaleLowerCase() === '.fdb'
		);
	}

	public get createAccountLabel() {
		const labels = {
			active: 'Create New Account',
			sending: 'Creating...',
			done: 'Created',
		};
		return labels[this.createAccountState];
	}
	public onCompanyNameChange() {
		this.companyName = this.companyName.trim();
	}
	public onPathChange() {
		this.path = this.path.replace(/\\/g, '/');
	}
	public onPayrollChange() {
		this.payroll = this.payroll.replace(/\\/g, '/');
	}

	public async createAccount() {
		if (this.createAccountState !== 'active') {
			return;
		}
		this.validateNow = true;
		this.path = this.path.replace('\\', '/');
		if (this.payroll) {
			this.payroll = this.payroll.replace('\\', '/');
		}
		if (!this.validateCompanyName || !this.validatePath) {
			return;
		}

		const submission: CreateAccountSubmission = {
			companyName: this.companyName,
			companyRemark: this.companyRemark || moment().format('DD/MM/YYYY'),
			path: this.path,
			payroll: this.payroll,
			interval: Number(this.interval),
			softwareType: this.softwareType,
			programId: this.programId,
		};
		const toastId = await progressToastx.add({
			title: `${this.companyName}`,
			state: `Creating New Account...`,
			variant: 'info',
		});
		this.createAccountState = 'sending';
		const result = await mwx.createAccount(submission);
		this.createAccountState = 'active';
		if (result.success) {
			this.validateNow = false;
			progressToastx.done({ id: toastId, state: `Account created!` });
			this.companyName = '';
			this.path = '';
			this.payroll = '';
		} else {
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
}
